import { styled } from '@linaria/react';
import { breakpoints, colors, fonts, layout, space } from '../../theme/tokens';

export const RecommendationsWrapper = styled.div`
  width: 100%;
  max-width: ${breakpoints.wide};
  margin: 0 auto;
  overflow: hidden;
`;

export const RecommendationsTitle = styled.h2`
  font-family: ${fonts.heading};
  font-size: 36px;
  font-weight: ${fonts.weight.normal};
  letter-spacing: -0.5px;
  line-height: 1.2;
  color: ${colors.fontPrimary};
  margin: 0;
`;

export const CenteredGrid = styled.div<{ $columns: number; $mobileColumns: number }>`
  --cols: ${({ $mobileColumns }) => $mobileColumns};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${space[5]};
  margin-bottom: ${space[10]};

  > * {
    flex: 0 0 calc((100% - (var(--cols) - 1) * ${space[5]}) / var(--cols));
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    --cols: ${({ $columns }) => $columns};
  }
`;

export const GridHeading = styled.p<{ $size?: 'base' | 'large' }>`
  margin: 0 0 ${({ $size }) => ($size === 'large' ? space[7] : space[5])};
  text-align: center;
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size['2xl']};
  line-height: 1.2;
  color: ${colors.fontPrimary};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${({ $size }) => ($size === 'large' ? fonts.size['3xl'] : fonts.size['2xl'])};
  }
`;

export const GridHeadingSecondary = styled.span`
  color: ${colors.fontSecondary};
`;
